var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.307,
    height: 14.307,
    viewBox: "0 0 14.307 14.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "array",
    transform: "translate(-1552.689 -917.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38197",
    "data-name": "Path 38197",
    d: "M.419,3.192a.419.419,0,0,0,.419-.419V.838H2.773a.419.419,0,0,0,0-.838H.419A.419.419,0,0,0,0,.419V2.773A.419.419,0,0,0,.419,3.192Z",
    transform: "translate(1552.689 917.791)",
    fill: "#848689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38198",
    "data-name": "Path 38198",
    d: "M400.538,0h-2.354a.419.419,0,1,0,0,.838h1.935V2.773a.419.419,0,1,0,.838,0V.419A.419.419,0,0,0,400.538,0Z",
    transform: "translate(1166.039 917.791)",
    fill: "#848689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38199",
    "data-name": "Path 38199",
    d: "M400.538,397.765a.419.419,0,0,0-.419.419v1.935h-1.935a.419.419,0,1,0,0,.838h2.354a.419.419,0,0,0,.419-.419v-2.354A.419.419,0,0,0,400.538,397.765Z",
    transform: "translate(1166.039 531.141)",
    fill: "#848689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38200",
    "data-name": "Path 38200",
    d: "M2.773,400.119H.838v-1.935a.419.419,0,1,0-.838,0v2.354a.419.419,0,0,0,.419.419H2.773a.419.419,0,1,0,0-.838Z",
    transform: "translate(1552.689 531.141)",
    fill: "#848689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38201",
    "data-name": "Path 38201",
    d: "M101.486,91.025V88.378a.238.238,0,0,0-.238-.238h-8.67a.238.238,0,0,0-.238.238v2.647a.238.238,0,0,0,.238.238h1.264a.238.238,0,0,0,.238-.238v-.907a.238.238,0,0,1,.238-.238H95.8a.238.238,0,0,1,.238.238V96.66a.238.238,0,0,1-.238.238h-.65a.238.238,0,0,0-.238.238V98.4a.238.238,0,0,0,.238.238h3.517a.238.238,0,0,0,.238-.238V97.136a.238.238,0,0,0-.238-.238h-.65a.238.238,0,0,1-.238-.238V90.118a.238.238,0,0,1,.238-.238h1.487a.238.238,0,0,1,.238.238v.907a.238.238,0,0,0,.238.238h1.264A.238.238,0,0,0,101.486,91.025Z",
    transform: "translate(1462.93 832.113)",
    fill: "#848689"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArray);
export default __webpack_public_path__ + "static/media/array.99499264.svg";
export { ForwardRef as ReactComponent };